import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAIzYYtd1vXU2P-RBJ9S4OJU3Q9EAQVX38",
  authDomain: "afterset-d19e4.firebaseapp.com",
  projectId: "afterset-d19e4",
  storageBucket: "afterset-d19e4.firebasestorage.app",
  messagingSenderId: "606637522633",
  appId: "1:606637522633:web:2592708fa80e3921425718"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);